import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { PolicyCancellationForm } from "../../Cancellation/PolicyCancellationForm";
import { MODULE_IDS, POLICIES, POLICIES_NAMES } from "../../../../../../constants/enums";
import { useCustomerPolicyDetails } from "../../../../../../hooks";

export const LifeInsuranceCancellation: React.FC = () => {
  const { taskCode } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    taskCode?: string;
  };

  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  const { details: policyAdmin, insurer, branch} = useCustomerPolicyDetails(customerPolicyId)

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(
      `/life-insurance-policy/${customerId}/policy-forms-tab/${customerPolicyId}?tab=0`
    );
  };
  return (
    <>
      {taskCode && (
        <PolicyCancellationForm
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          handleNavigate={handleNavigate}
          agencyBill={null}
          policy={POLICIES_NAMES.LIFE_AND_FINCANCIAL_POLICY}
          lineOfBusiness={POLICIES.LIFE_AND_FINCANCIAL_POLICY}
          subType={null}
          customerCode={null}
          customerName={null}
          policyNumber={null}
           branch={branch.name}
          broker_code={branch.branch_code}
          producer_one_code={policyAdmin.data.producer_one_code}
          producer_one_id={policyAdmin.data.producer_one}
          csr={policyAdmin.data.csr}
          insurer={insurer.insurer_code}
          securityType={`${MODULE_IDS.LIFE_AND_FINCANCIAL}`}
        />
      )}
    </>
  );
};
